<div class="container">
  <div class="row center-component">
    <div class="col-md-6">
      <mat-form-field class="fullWidthBtn">
        <input
          #box
          type="search"
          matInput
          [formControl]="searchField"
          placeholder="{{ 'DISPOSITIVOS.SEARCH' | translate }}"
          [matAutocomplete]="auto"
          (keyup.enter)="onEnter(box.value)"
        />
        <i class="material-icons">search</i>
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option
            *ngFor="let dispositivo of results | async"
            [value]="dispositivo.name"
          >
            {{ dispositivo.name }}
            <!-- TODO: Revisar -->
            <!-- <span class="device-factory"
              >({{ dispositivo.factoryName }}-{{ dispositivo.groupName }})</span
            > -->
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="fullWidthBtn adjust-height">
        <mat-label>Tipo de Datos</mat-label>
        <mat-select (valueChange)="onTypeDataChange($event)">
          <mat-option value="1">tipo dato 1</mat-option>
          <mat-option value="2">tipo dato 2</mat-option>
          <mat-option value="3">tipo dato 3</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-1 text-center">
      <button
        mat-icon-button
        class="colorGreenHighlight marginTop8"
        (click)="addDevice()"
      >
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>
  </div>
</div>
